<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">支付宝红包</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="rechargebottonbox">
      <div class="rechargebotton" @click="toorder">充值记录</div>
    </div>
    <div class="alipaypagebox">
      <div class="rechargetopbox">
        <div class="rechargetipline">
          <div class="rechargetongyong">全国通用</div>
          <div class="rechargetip">请核对好充值号码、不可退换、不可延期</div>
        </div>
        <div class="rechargephonetext">手机号码</div>
        <div class="rechargephonebox">
          <input class="rechargetelinput" placeholder="请输入需要充值的手机号码" type="tel" v-model="chargeNum" value="phoneSlow" />
        </div>
        <div class="rechargepricetext">请选择充值金额</div>
        <div class="rechargepricelist">
          <div :class="item.checked? 'rechargepricebox1' :'rechargepricebox' " v-for="(item,index) in list" @click="changerechargenum(index)">
            <div>{{item.m_price}}元</div>
            <img v-if="item.checked" class="rechargecheck" src="/static/newprojecticon/chongzhicheck.png" />
          </div>
        </div>
        <div class="rechargenotebox">
          <div class="rechargenotetitle">注意事项：</div>
          <div class="rechagrgenote">1、请核对录入的<span style="color: #029DFF;">手机号是否正确</span>如果<span style="color: #029DFF;">录入错误无法返回</span>，
            造成的<span style="color: #029DFF;">损失由个人承担
            </span></div>
          <div class="rechagrgenote">2、使用支付宝消费时会自动提示有红包可用</div>
          <div class="rechagrgenote">3、红包卡券有有效期，具体请到<span style="color: #029DFF;">支付宝卡包</span>查看</div>
          <div class="rechagrgenote">4、<span style="color: #029DFF;">充值成功后，无法退款</span></div>
        </div>

        <div class="accountbox">
          <div class="accounttext">积分抵扣</div>
          <div class="accountprice">-{{payAmount}}</div>
        </div>
        <div class="paypricebox">应付：<span style="color: #FD0303;">￥{{payAmount}}</span></div>

      </div>
      <div class="usenotebox">
        <img class="userimg" @click="toweburl" src="../../../static/lijishiyong.png" />
        <img class="userimg" @click="tousedetail" src="../../../static/shiyongjiaocheng.png" />
      </div>
      <div class="nonenox"></div>
    </div>
    <div class="rechargebottom">
      <!-- <div class="rechargebottomnote">充值即表示您同意<span style="color: #029DFF;">《优越服务支付宝红包充值服务协议》</span></div>
      -->
      <div class="rechargebottombox">
        <div class="rechargebotprice">￥{{payAmount}}</div>
        <div class="rechargebottomb" @click="buttonClicked  ? '' :  toRecharge()">立即充值</div>
      </div>
    </div>
    <!--
    <div>
      <div class="page_top">
        <div class="page_pname">手机号码</div>
        <div class="page_pnum">
          <input class="page_pnuminputphone" placeholder="请输入手机号" type="tel" v-model="chargeNum" value="phoneSlow" />
        </div>
        <div class="page_pnum" v-if="phone!=chargeNum">
          <input class="page_pnuminputphone1" type="number" placeholder="请输入验证码" v-model="phoneCode" />
          <div class="phone_yanzheng" @click='getPhoneCode()'>{{ currentTime ? currentTime : "获取验证码" }}</div>
        </div>
      </div>
      <div class="page_taocan phone_taocan1">
        <div class="page_taocan_name">请选择充值金额</div>
        <div class="page_taocan_list">
          <div :class="item.checked? 'page_taocan_box1' :'page_taocan_box' " class="phone_tocan_box" v-for="(item,index) in list"
            @click="changerechargenum(index)">
            <div class="page_taocan_num phone_num" style="font-size: 20px;">{{item.m_price}}元</div>
            <img v-if="item.checked" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
          </div>
        </div>
      </div>
      <div class="page_button phone_button1" @click="buttonClicked  ? '' :  toRecharge()">
        <div class="page_zhifu">立即支付（{{payAmount}}积分）</div>
      </div>
      <div class="page_mesg">
        <div class="page_mesgtitle">
          <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
          <div class="page_mesgtext">注意事项</div>
        </div>
        <div class="page_mesgtip">1、请核对录入的手机号是否正确，如果录入错误无法返回，造成的损失由个人承担</div>
        <div class="page_mesgtip">2、使用支付宝消费时会自动提示有红包可用</div>
        <div class="page_mesgtip">3、红包卡券有有效期，具体请到支付宝卡包查看</div>
        <div class="page_mesgtip" style="color: #029dff">4、充值成功后，无法退款</div>
      </div>
    </div> -->
    <div v-if="showlodaing" class="mengban"></div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  import httpers from '../../api/https';
  import {
    Dialog
  } from 'vant';
  var phone_mreg = /^1[2-9][0-9]{9}$/;
  import {
    Toast
  } from 'vant';
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  const closeLoading = setTimeout(() => {
    Toast.clear();
  }, 100)
  export default {
    data() {
      return {
        phonetopHead: [{
            name: "慢充",
            topselect: false,
          },
          {
            name: "快充",
            topselect: true,
          }
        ],
        phonetopheadindex: 1,
        // isData: 'slowCharge', // 用户点击选中慢充话费，否则快充话费
        isData: 'phoneBills', //用户点击选中慢充话费，否则快充话费
        price: "", //套餐价格
        priceSlow: "", //慢充套餐价格
        amount: 0, // 接口获取用户可用余额,默认为0
        chargeNum: '', // 所快充值的手机号码
        buttonClicked: false, // 防止支付重复点击,默认为false
        list: [], // 接口获取列表
        phone: "", //默认手机号
        phoneCode: '', // 验证码,默认为空
        currentCode: '', // 接口获取正确的验证码,默认为空
        currentTime: '', // 验证码倒计时,默认为空
        phoneCodeStatus: false, // 验证码状态,默认为false
        isWeixinPay: false,
        slowcharge: false, //慢充
        product: [], //充值
        rechargeList: [{
          amount: 50,
          name: "50元",
          checked: true,
          id: 1
        }, {
          amount: 100,
          name: "100元",
          checked: false,
          id: 2
        }, {
          amount: 200,
          name: "200元",
          checked: false,
          id: 3
        }, {
          amount: 300,
          name: "300元",
          checked: false,
          id: 4
        }, {
          amount: 500,
          name: "500元",
          checked: false,
          id: 5
        }, {
          amount: 1000,
          name: "1000元",
          checked: false,
          id: 6
        }],
        payAmount: 50,
        amountid: 1,
        sendSmsSign: "", //短信签名
        userInfo: {}, //用户信息
        availableUser: false, //是否为可用用户
        showlodaing: false
      }
    },
    created() {
      let that = this
      that.request('getProductList', {
        tab_id: 5
      })
      that.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      toorder() {
        // this.$router.push({
        //   path: "/orderList",
        //   product_id:"221"
        // })
        this.$router.push({
          path: "alipayorder",
          query: {
            product_id: 221
          }
        })
      },

      tousedetail() {
        this.$router.push({
          path: "usealipay"
        })
      },
      toweburl() {
        window.location.href = "https://ulink.alipay.com/?scheme=alipayqr://platformapi/startapp?saId=20000021"
        // if (!url) {
        //   return
        // } else {
        //   window.location.href = url
        // }
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },

      //改变套餐
      changerechargenum(e) {
        this.list.map((item, index) => item.checked = index === e)
        this.payAmount = parseFloat(this.list[e].price).toFixed(2)
        // this.payAmount = this.rechargeList[Number(e)].amount
      },


      //微信支付
      weixinPay() {
        this.isWeixinPay = true
      },
      //余额支付
      yuePay() {
        this.isWeixinPay = false
      },
      //支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        let product_item_id = 0
        for (let i in this.list) {
          if (this.list[i].checked) {
            product_item_id = this.list[i].id
          }
        }
        order_param.amount = that.payAmount
        if (!phone_mreg.test(that.chargeNum)) {
          this.$toast({
            message: '手机号格式错误'
          })
          return
        }
        order_param.product_type = 3
        order_param.product_item_id = product_item_id
        order_param.recharge_number = that.chargeNum
        if (that.phone != that.chargeNum) {
          if (!that.phoneCode || that.phoneCode != that.currentCode) {
            this.$toast({
              message: '请输入正确的验证码'
            })
            return
          }
        }
        // if (!that.phoneCode) {
        //   this.$toast({
        //     message: '请输入验证码'
        //   })
        //   return
        // }
        // order_param.verifyCode = that.phoneCode
        // order_param.sendSmsSign = that.sendSmsSign
        //快充
        if (parseFloat(this.payAmount) > parseFloat(this.amount)) {
          Dialog.confirm({
              title: '提示',
              message: '积分不足，前往充值？',
            })
            .then(() => {
              that.$router.push({
                path: "/account"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          Dialog.confirm({
              title: '提示',
              message: '请认真核对手机号码\n' + that.chargeNum + '\n充错无法返回',
            })
            .then(() => {
              order_param.type = 'online'
              order_param.pay_type = 'balance'
              console.log("order_param", order_param)
              openLoading()
              this.showlodaing = true
              that.request('YeunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        }
      },
      // test(){
      //   let that = this
      //   setTimeout(() => {
      //     Toast.clear();
      //      that.showlodaing = false
      //   }, 3000)

      //   console.log("测试")
      // },
      //输入手机号时触发
      // phoneNum() {
      //   let that = this
      //   that.chargeNum = this.chargeNum
      //   console.log("that.chargeNum",that.chargeNum)
      //   that.phoneCodeStatus = phone_mreg.test(this.chargeNum)
      // },
      //获取验证码
      getPhoneCode() {
        let that = this
        let requestData = {}
        // 获取验证码
        that.buttonClickedFun(1500)
        console.log("phone_mreg.test(this.chargeNum)", phone_mreg.test(this.chargeNum))
        if (!phone_mreg.test(this.chargeNum)) {
          this.$toast({
            message: '请输入正确的手机号',
          })
          return
        }
        if (!that.chargeNum) {
          this.$toast({
            message: '请输入手机号',
          })
          return
        }
        // requestData.amount = that.payAmount
        requestData.mobile = that.chargeNum
        this.request('sendCode', requestData)

      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取个人信息余额
          case 'getUserInfo':
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code === 0) {
                that.userInfo = res.data
                // var userId = [167,168]
                // for (var i = 0; i < userId.length; i++) {
                //   if (userId[i] == that.userInfo.id) {
                //     that.availableUser = true
                //   }
                // }
                let amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                that.phone = res.data.mobile
                that.chargeNum = that.phone
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            // getProductList
            //刚进入页面获取的数据
          case 'getProductList':
            httper.get('/product/get-online-by-api-tab', requestData, function(res) {
              if (res.code === 0) {
                // that.tldlist = res.data
                var product = res.data
                // var list = []
                // list.phoneBills = product[0].productItem
                let list = product[0].productItem
                // list.map(v => {
                //   that.$set(v, 'checked', false)
                //   return v
                // })
                // list[0].checked = true

                //list.phoneBills = product[0].productItem
                for (let i in list)
                  list[i].checked = false
                list[0].checked = true
                that.payAmount = parseFloat(list[0].price).toFixed(2)
                // let price = parseFloat(list.phoneBills[0].price).toFixed(2)
                // let wxPrice = parseFloat(list.phoneBills[0].price).toFixed(2)
                //let canAmountPay = (that.amount - price) >= 0
                console.log("列表", list)
                that.list = list
                //that.price = price
              } else {
                that.$toast({
                  message: res.data.message || '系统异常',
                })
              }
            }, true)
            break
            // 发送短息验证码
          case 'sendCode':
            httpers.post('msg/send-code', requestData, res => {
              if (res.code == 0) {
                console.log("短信", res)
                that.currentCode = res.data
                this.$toast({
                  message: '验证码已发送',
                });
                // 倒计时
                let time = 91
                let interval = setInterval(() => {
                  time--
                  if (time > 10) {
                    that.currentTime = time + '秒'
                  }
                  if (time > 0 && time <= 10) {
                    that.currentTime = ' ' + time + '秒'
                  }
                  if (time <= 0) {
                    clearInterval(interval)
                    that.currentTime = ''
                  }
                }, 1000)
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              if (res.code == 0) {
                setTimeout(() => {
                  Toast.clear();
                  that.showlodaing = false
                }, 100)
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
                // this.$router.push({
                //   path: "alipayorderDetail",
                //   query: {
                //     id: res.data.order_no
                //   }
                // })
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  .phone_taocan {
    height: 170px;
  }

  .phone_taocan1 {
    height: 170px;
    top: -35px;
  }

  .phone_num {
    font-size: 22px;
    font-weight: bold;
  }

  .phone_yanzheng {
    width: 30%;
    height: 31px;
    border: 1px solid #fff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::-webkit-input-placeholder {
    text-align: start !important;
    /*  color: hsla(0, 0%, 100%, 1); */
    color: #666666;
    font-size: 15px;
  }

  .phone_tocan_box {
    margin: 5px;

  }

  .phone_button {
    /* margin-top: 170px; */
    margin-top: 20px;
  }

  .page_pnuminputphone {
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: bold;

  }

  .page_pnuminputphone1 {
    width: 70%;
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: bold;

  }

  .phone_button1 {
    /* margin: 190px 30px 0 30px; */
    margin: 30px 30px 0 30px;
  }

  .phonetype_taocan {
    width: calc(100% - 40px);
    margin: 20px;
    margin-top: -60px;
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
    padding: 20px 10px;
    box-sizing: border-box;
  }

  .phonetype_taocan1 {
    width: calc(100% - 40px);
    margin: 20px;
    margin-top: -20px;
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
    padding: 20px 10px;
    box-sizing: border-box;
  }

  .mengban {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9;
  }

  .rechargebottonbox {
    width: 100%;
    background-color: #FFFFFF;
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .rechargebotton {
    width: 88px;
    height: 31px;
    background: #D2EAF8;
    border-radius: 15px;
    font-size: 15px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rechargetopbox {
    width: calc(100% - 40px);
    margin: 20px;
    padding: 15px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
  }

  .rechargetipline {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .rechargetongyong {
    width: 58px;
    height: 19px;
    border: 1px solid #E60012;
    border-radius: 2px;
    font-size: 12px;
    color: #FF0202;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rechargetip {
    font-size: 12px;
    color: #666666;
  }

  .rechargephonetext {
    font-size: 15px;
    margin-bottom: 15px;
  }

  .rechargephonebox {
    width: 100%;
    height: 46px;
    border: 1px solid #FD8C00;
    border-radius: 2px;
    margin-bottom: 15px;
    padding: 10px;
    box-sizing: border-box;

  }

  .rechargetelinput {
    width: 100%;
    font-size: 15px;
    border: none;
    outline: none;
  }

  .rechargepricetext {
    font-size: 15px;
  }

  .rechargepricelist {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .rechargepricebox {
    width: 92px;
    height: 46px;
    border: 1px solid #7D7D7D;
    font-size: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
  }

  .rechargepricebox1 {
    width: 92px;
    height: 46px;
    border: 1px solid #FD8C00;
    font-size: 19px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
    position: relative;
  }

  .rechargecheck {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .rechargenotebox {
    width: 100%;
    margin: 15px 0;
    padding: 15px;
    box-sizing: border-box;
    background-color: #D2EAF8;
  }

  .rechargenotetitle {
    font-size: 12px;
    color: #FD8C00;
    margin-bottom: 10px;
  }

  .rechagrgenote {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .accountbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .accounttext {
    font-size: 14px;
  }

  .accountprice {
    font-size: 14px;
    color: #FD0303;
  }

  .paypricebox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
  }

  .usenotebox {
    width: calc(100% - 40px);
    margin: 0 15px 20px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .userimg {
    width: 163px;
    height: 96px;
    border-radius: 8px;
  }

  .rechargebottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .rechargebottomnote {
    width: 100%;
    padding: 10px 26px;
    box-sizing: border-box;
    background-color: #f4c6c9;
    font-size: 14px;
    color: #FF0202;
  }

  .rechargebottombox {
    width: 100%;
    padding: 26px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rechargebotprice {
    font-size: 15px;
    color: #FF0202;
  }

  .rechargebottomb {
    width: 153px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }

  .nonenox {
    width: 100%;
    height: 120px;
    background-color: #F7F7F7;
  }

  .alipaypagebox {
    width: 100%;
    background-color: #F7F7F7;
padding-top: 1px;
box-sizing: border-box;

  }
</style>



// WEBPACK FOOTER //
// src/pages/alipaypage/alipay.vue